<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'reports.view.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    @if (report().documentUrl) {
      <app-document-preview [uri]="reportUrl()"></app-document-preview>
    } @else {
      <report-viewer
        [reportId]="report().id"
        [fileName]="downloadFileName()"
      ></report-viewer>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dismiss()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
